import React, { Component } from "react";
import { Loader, Pagination, Panel, Table, Warning } from "@culturehq/components";
import client from "@culturehq/client";

import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";

import SlackUserRow from "./users/SlackUserRow";

class SlackUsers extends Component {
  state = {
    error: false,
    loading: true,
    pagination: {},
    users: [],
    query: null,
    page: 1
  };

  componentDidMount() {
    this.fetchUsers();
  }

  componentDidUpdate(_, prevState) {
    const { page, query } = this.state;

    if (
      (page !== prevState.page && !query)
      || (query !== prevState.query && !query)
    ) {
      this.fetchUsers();
    }
  }

  handlePageSelected = page => {
    this.setState({ page });
  };

  async fetchUsers() {
    const { page } = this.state;

    this.setState({ loading: true });

    try {
      const { users, pagination } = await client.listUsers({ page, slack: 1 });

      this.setState({ loading: false, error: false, users, pagination });
    } catch (error) {
      this.setState({ loading: false, error });
    }
  }

  render() {
    const { users, loading, pagination, error } = this.state;

    return (
      <Panel limitWidth>
        <Panel.Heading primary>Users</Panel.Heading>
        <Panel.Body className="ManageUsers">
          {error && <ErrorMessage error={error} />}

          <Loader loading={loading}>
            <Table className="no-scrollbar">
              <thead>
                <tr>
                  <th />
                  <th><Trans>Name</Trans></th>
                  <th><Trans>Slack Team Id</Trans></th>
                  <th><Trans>Slack Id</Trans></th>
                  <th><Trans>Status</Trans></th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <SlackUserRow
                    key={user.id}
                    user={user}
                  />
                ))}
              </tbody>
            </Table>

            {users.length < 1 && (
              <Warning><Trans>No results to show.</Trans></Warning>
            )}

            <Pagination {...pagination} onClick={this.handlePageSelected} />
          </Loader>
        </Panel.Body>
      </Panel>
    );
  }
}

export default SlackUsers;
